const zIndex1 = 100;
const zIndex2 = 200;
const zIndex3 = 300;
/* eslint-disable-next-line */
const zIndex4 = 400;
/* eslint-disable-next-line */
const zIndex5 = 500;
/* eslint-disable-next-line */
const zIndex6 = 600;
const zIndex8 = 800;
const zIndex9 = 910;
const zIndex10 = 1000;

const zIndexNeg1 = -1;

export default {
  hint: zIndex1,
  mainTab: zIndex1,
  HotMarkets: zIndex1,
  FormTitleContent: zIndex1,
  dropdown: zIndex2,
  calendar: zIndex2,
  caption: zIndex3,
  nav: zIndex9,
  loading: zIndex8,
  shade: zIndex8,
  tooltip: zIndex9,
  proMiniSymbols: zIndex9,
  topNav: zIndex9,
  fullScreen: zIndex10,
  modal: zIndex10,
  fixedTab: zIndex9,
  depthBar: zIndexNeg1,
  activityBox: zIndex1,
  googleTranslateBox: zIndex6,
  allowCookiesWindow: zIndex9,
  goToMobileSiteTip: zIndex10,
};
